import { render, staticRenderFns } from "./CadenceFlagQueue.vue?vue&type=template&id=24d88bf2&scoped=true"
import script from "./CadenceFlagQueue.vue?vue&type=script&lang=js"
export * from "./CadenceFlagQueue.vue?vue&type=script&lang=js"
import style0 from "./CadenceFlagQueue.vue?vue&type=style&index=0&id=24d88bf2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24d88bf2",
  null
  
)

export default component.exports